import MaterialIcon from "../../../MaterialIcon";
import React from "react";

export const PanelLayoutHeader = (props) => {
    const {handleClose, children} = props;

    return (
        <div className={`gui-editor-header`}>
            <div className="close-button" onClick={handleClose}>
                <MaterialIcon icon="close" size={24}/>
            </div>
            <div className="simple-navigation">
                {children}
            </div>
        </div>
    )
}